import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-exports',
  templateUrl: './help-exports.component.html',
  styleUrls: ['./help-exports.component.scss']
})
export class HelpExportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
